module.exports = __webpack_public_path__ + "assets/tingzhenqi.f201976c.svg";